import { render, staticRenderFns } from "./cust_sup.vue?vue&type=template&id=d973465a&scoped=true&"
import script from "./cust_sup.vue?vue&type=script&lang=js&"
export * from "./cust_sup.vue?vue&type=script&lang=js&"
import style0 from "./cust_sup.vue?vue&type=style&index=0&id=d973465a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d973465a",
  null
  
)

export default component.exports